import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { ProjectsGetResultApi } from 'api-typings/projects/projects';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    projects: ProjectsGetResultApi;
  }
}

export const projectsBackend: Backend<'projects'> = {
  fetch: (_, projectIds, query) => ({
    endpoint: `projects/0.1/projects`,
    params: {
      projects: projectIds || [],
      owners: query ? getQueryParamValue(query, 'ownerId') : [],
      frontend_project_statuses: query
        ? getQueryParamValue(query, 'frontendProjectStatus')
        : [],
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/projects/projects.backend.ts